namespace gotoAndPlay {

    interface INewsletterSettings {
        openClass?: string;
        toggleClass?: string;
    }

    class Newsletter {
        element: JQuery;
        settings: INewsletterSettings;
        toggle: JQuery;
        form: JQuery;

        constructor(target: JQuery) {
            this.settings = {
                openClass: 'is-open',
                toggleClass: 'js-newsletter-toggle',
            };

            this.element = target;
            this.toggle  = this.element.find('.' + this.settings.toggleClass);
            this.form    = this.element.find('.js-newsletter-submit');

            this.init();

            this.form.on('submit', (event) => {
                this.submit(event);
            });
        }

        init(): void {
            if (this.toggle) {
                this.toggle.on('click', this.openContent.bind(this));
            }
        }

        openContent(): void {
            this.element.toggleClass(this.settings.openClass);
        }

        submit(event): void {
            let email1 = this.form.find('#email1').val();
            let email2 = this.form.find('#email2').val();
            event.preventDefault();
            let validation = this.validateEmails(email1, email2);
            if (validation.isValid) {
                $('.newsletter__form-validation-error').addClass('h-hidden');
                let data = {
                    email: email1,
                };
                $.post(ajaxPath, {
                    action: 'add_subscriber',
                    data: data,
                }, function(response) {
                    switch (response['status']) {
                        case 'success':
                            $('.newsletter__form-content').addClass('h-hidden');
                            $('.newsletter__form-success').removeClass('h-hidden');

                            let pageTemplateName = $('#page-template-name').val();
                            if (typeof dataLayer !== 'undefined') {
                                dataLayer.push({ event : 'AutoEvent', eventCategory : pageTemplateName, eventAction : 'Liitu DT klubiga - Kinnitus' });
                            }

                            break;

                        case 'already_member':
                            $('.newsletter__form-error').removeClass('h-hidden');
                            break;

                        default:
                            $('.newsletter__form-validation-error').html('Midagi läks valesti. Proovi natukese aja pärast uuesti!');
                            $('.newsletter__form-validation-error').removeClass('h-hidden');
                            break;
                    }
                });
            } else {
                $('.newsletter__form-validation-error').html(validation.errors[0]);
                $('.newsletter__form-validation-error').removeClass('h-hidden');
            }
        }

        validateEmails(email1, email2) {
            let errors           = [];
            let isValid: boolean = true;
            if (email1 != email2) {
                isValid = false;
                errors.push('Sisestatud e-posti aadressid ei ole samad!');
            }
            if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email1)) {
                isValid = false;
                errors.push('Sisestatud e-posti aadressid ei ole korrektsed');
            }

            return {
                isValid: isValid,
                errors: errors,
            };
        }
    }

    // Init on document ready
    export let newsletter;
    $(function() {
        newsletter = new Newsletter($('.newsletter'));
    });
}
